import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeafletMapComponent } from './leafletMap.component';

import "leaflet/dist/leaflet.css?global";
import { MapComputationModule } from '../computation/map-computation.module';
import { NominatimResourceService } from './nominatim-resource-service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormFieldModule } from 'libraries/module/formbuilder/fields/form-field/form-field.module';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { HTMLMarkerComponent } from "./HTMLMarker.component";

@NgModule({
    imports: [
        CommonModule,
        MapComputationModule,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
        FormsModule,
        FormFieldModule,
        ReactiveFormsModule,
        FontAwesomeModule,
    ],
    declarations: [
        LeafletMapComponent,
        HTMLMarkerComponent,
    ],
    exports: [
        LeafletMapComponent,
    ],
    providers: [
        NominatimResourceService,
    ],
    entryComponents: [
        HTMLMarkerComponent
    ]
})
export class LeafletMapModule { }
